<template>
	<div>
	<c-dialog ref="dialog" mode="slide" width="50vw" mask-close>
		<template #head>
			<div v-if="afterSale.after_sale_no" class="m-detail-tag flex-center-cross">
				<label>{{afterSale.after_sale_no}}</label>
				<c-state tag async dict="SALE_AFTER_SALE_STATE" :value="afterSale.after_sale_state"></c-state>
			</div>
		</template>

		<div class="m-after-sale-detail flex-column">
			<div class="flex-grow">
                <c-title >基础信息</c-title>
                <!-- 产品信息详情 -->
                <c-detail class="m-detail-table" column="2">
                    <c-detail-item label="订单号" colspan="2">{{afterSale.order_no || '-'}}</c-detail-item>
                    <c-detail-item label="创建时间" colspan="2">{{afterSale.create_date || '-'}}</c-detail-item>
                    <c-detail-item label="售出价">{{formatPrice(product.sale_price)}}</c-detail-item>
                    <c-detail-item label="售后类型">
                        <c-state async dict="SALE_AFTER_SALE_TYPE" :value="afterSale.after_sale_type"></c-state>
                    </c-detail-item>
                    <c-detail-item :label="afterSale.after_sale_type==1 ? '退款金额' : '补差金额'">
                        <span class="m-amount">{{formatPrice(afterSale.after_sale_amount)}}</span>
                    </c-detail-item>
                    <c-detail-item label="退款信息">
                        <span v-if="!Number(afterSale.refund_amount)">-</span>
                        <div v-else class="m-product-info">
                            <p class="m-amount">{{formatPrice(afterSale.refund_amount)}}</p>
                            <p class="m-product-info-code">{{afterSale.refund_date || '-'}}</p>
                        </div>
                    </c-detail-item>
                    <c-detail-item label="售后原因" >{{afterSale.refund_reason || '-'}}</c-detail-item>
                </c-detail>

                <!-- 产品信息详情 -->
                <c-title >产品信息</c-title>
                <!-- 产品名称标题 -->
                <h3 class="m-product-title">{{getProductFullName()}}</h3>
				<c-detail class="m-detail-table" column="2">
					<c-detail-item label="品牌/型号" colspan="2">{{getBrandModelText()}}</c-detail-item>
					<c-detail-item label="背贴码" colspan="2">{{product.produce_code || '-'}}</c-detail-item>
					<c-detail-item label="IMEI" colspan="2">{{product.imei || '-'}}</c-detail-item>
					<c-detail-item label="分类">{{product.category_name || '-'}}</c-detail-item>
					<c-detail-item label="等级">{{product.level_name || '-'}}</c-detail-item>
					<c-detail-item label="内存">{{product.memory_name || '-'}}</c-detail-item>
					<c-detail-item label="颜色">{{product.color_name || '-'}}</c-detail-item>
				</c-detail>


                <template v-if="afterSale.after_sale_state ==2 || afterSale.after_sale_state == 6">
                    <c-title>审批信息</c-title>
                    <c-detail class="m-detail-table" column="2">
                        <c-detail-item label="审批人">{{afterSale.audit_user_realname || '-'}}</c-detail-item>
                        <c-detail-item label="审批时间">{{afterSale.audit_date || '-'}}</c-detail-item>
                        <c-detail-item label="驳回原因">{{afterSale.audit_remark || '-'}}</c-detail-item>
                    </c-detail>
                </template>
                <template v-if="afterSale.after_sale_state == 7">
                    <c-title>撤销信息</c-title>
                    <c-detail class="m-detail-table" column="2">
                        <c-detail-item label="撤销人">{{afterSale.cancel_user_realname || '-'}}</c-detail-item>
                        <c-detail-item label="撤销时间">{{afterSale.cancel_date || '-'}}</c-detail-item>
                    </c-detail>
                </template>
			</div>
		</div>

        <template #button>
            <c-button v-if="auth('b_offline_aftersales_order_audit') && afterSale.order_type == 1 && afterSale.after_sale_state == 1"  size="dialog"  color="main" @click="handleAudit(2)">审批通过</c-button>
            <c-button v-if="auth('b_offline_aftersales_order_audit') && afterSale.order_type == 1 && afterSale.after_sale_state == 1" size="dialog" color="red" @click="handleAudit(6)">驳回申请</c-button>
            <c-button v-if="auth('b_online_aftersales_order_audit') && afterSale.order_type == 2 && afterSale.after_sale_state == 1" size="dialog" color="main" @click="handleOnlineAudit">同意申请</c-button>
        </template>
	</c-dialog>

	<!-- 驳回申请弹窗 -->
	<c-dialog ref="rejectDialog" title="驳回申请" width="480">
		<div class="m-reject-box">
			<label class="m-label"><span class="m-required">*</span> 驳回原因</label>
			<c-input v-model="auditRemark" type="textarea" placeholder="请输入驳回原因" maxlength="200"></c-input>
		</div>

		<template #button>
			<c-button size="dialog" color="red" @click="submitReject">确认驳回</c-button>
			<c-button size="dialog" @click="$refs.rejectDialog.close()">取消</c-button>
		</template>
	</c-dialog>
	</div>
</template>

<script>
	export default {
		name: 'offlineAftersaleDetail',

		data() {
			return {
				afterSaleId: '',
				productId: '',
				afterSale: {},
				product: {},
				auditRemark: '',
				addressList: [],
				selectedAddressId: '',
				refundAmount: ''
			}
		},

		methods: {
			/*********打开抽屉**********/
			open(data = {}) {
				this.afterSaleId = data.afterSaleId;
				this.productId = data.productId;
				this.afterSale = {};
				this.product = {};
				this.$refs.dialog.open({title: '线下售后单详情'});
				this.loadDetail();
			},

			/*********加载售后商品详情**********/
			loadDetail() {
				this.request({
					url: '/aftersale/product_detail',
					data: {
						id: this.afterSaleId,
						after_sale_product_id: this.productId
					},
					loading: true,
					success: data => {
						this.afterSale = data.order_info || {};
						this.product = data.product_info || {};
					}
				});
			},

			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + parseFloat(price).toFixed(2);
			},

			/*********获取完整产品名称**********/
			getProductFullName() {
				var p = this.product;
				var parts = [];
				if (p.brand_name) parts.push(p.brand_name);
				if (p.model_name) parts.push(p.model_name);
				if (p.color_name) parts.push(p.color_name);
				if (p.memory_name) parts.push(p.memory_name);
				return parts.join(' ') || this.afterSale.product_name || '-';
			},

			/*********获取品牌/型号文本**********/
			getBrandModelText() {
				var p = this.product;
				var parts = [];
				if (p.brand_name) parts.push(p.brand_name);
				if (p.model_name) parts.push(p.model_name);
				return parts.join(' / ') || '-';
			},

			/*********审批通过（直接确认）/驳回申请（弹窗填写驳回原因）**********/
			handleAudit(auditState) {
				if (auditState == 6) {
					this.auditRemark = '';
					this.$refs.rejectDialog.open();
					return;
				}
				this.$confirm({
					message: '确认审批通过该售后单吗？',
					buttonName: '确定',
					cancelButton: true,
					resolve: () => {
						this.submitAudit(2);
					}
				});
			},

			/*********提交驳回（驳回原因必填）**********/
			submitReject() {
				if (!this.auditRemark.trim()) {
					this.$message({message: '请输入驳回原因', type: 'warn'});
					return;
				}
				this.submitAudit(6, this.auditRemark.trim(), null, 'rejectDialog');
			},

			/*********提交审核结果**********/
			submitAudit(auditState, auditRemark, extraData, closeRef) {
				var data = {
					id: this.afterSaleId,
					audit_state: auditState
				};
				if (auditRemark) {
					data.audit_remark = auditRemark;
				}
				if (extraData) {
					Object.assign(data, extraData);
				}
				this.request({
					url: '/aftersale/audit_offline',
					data: data,
					loading: true,
					success: (data, msg) => {
                        if (auditState != 2){
                            this.$message({message: msg || (auditState != 2 ? '审批通过' : '已驳回'), type: 'success'});
                            if (closeRef) {
                                this.$refs[closeRef].close();
                            }
                            this.$refs.dialog.close();
                            this.$emit('resolve');
                        }else {
                            this.$confirm({
                                type: 'success',
                                message: msg,
                                buttonName: '知道了',
                                cancelButton: false,
                                resolve: () => {
                                    if (closeRef) {
                                        this.$refs[closeRef].close();
                                    }
                                    this.$refs.dialog.close();
                                    this.$emit('resolve');
                                }
                            });
                        }
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-after-sale-detail {
		padding: 20px 30px;
	}

	.m-product-title {
		text-align: center;
		font-size: 16px;
		font-weight: bold;
		margin: 0 0 20px 0;
		color: #333;
	}

	// 详情表格样式微调（c-detail默认带边框表格外观）
	.m-detail-table {
		::v-deep .c-detail-item-label {
			background-color: #fafafa;
			color: #666;
			text-align: right;
		}

		.m-amount {
			color: #e53e3e;
			font-weight: bold;
		}
	}

	.m-button-group {
		display: flex;
		justify-content: flex-end;
		gap: 10px;
	}

	.m-detail-tag {
		gap: 8px;
		font-size: 14px;
		font-weight: bold;
	}

	.m-reject-box {
		padding: 10px;

		.m-label {
			display: block;
			margin-bottom: 8px;
			font-size: 14px;
			color: #333;

			.m-required {
				color: #f5222d;
				margin-right: 2px;
			}
		}
	}

	.m-return-address-box,
	.m-refund-amount-box {
		padding: 10px;

		.m-label {
			display: block;
			margin-bottom: 8px;
			font-size: 14px;
			color: #333;

			.m-required {
				color: #f5222d;
				margin-right: 2px;
			}
		}
	}

	.m-return-address-list {
		max-height: 320px;
		overflow-y: auto;

		.m-return-address-item {
			display: flex;
			align-items: flex-start;
			gap: 8px;
			padding: 10px 4px;
			cursor: pointer;
			font-size: 13px;
			color: #333;

			.m-radio {
				flex-shrink: 0;
				width: 14px;
				height: 14px;
				margin-top: 3px;
				border-radius: 50%;
				border: 1px solid #ccc;
				position: relative;
			}

			&.m-active {
				.m-radio {
					border: 2px solid #333;

					&::after {
						content: '';
						position: absolute;
						left: 2px;
						top: 2px;
						width: 6px;
						height: 6px;
						border-radius: 50%;
						background: #333;
					}
				}
			}
		}

		.m-return-address-empty {
			text-align: center;
			color: #999;
			padding: 30px 0;
			font-size: 13px;
		}
	}

	.m-refund-amount-input {
		display: flex;
		align-items: stretch;

		.m-unit {
			display: flex;
			align-items: center;
			padding: 0 12px;
			border: 1px solid #dcdfe6;
			border-left: none;
			background: #f5f7fa;
			color: #666;
			font-size: 13px;
		}
	}
</style>
